import React from 'react'
import './ProjectApproach.css'

const ProjectApproach = ({ onContact }) => (
    <aside className="project-approach" aria-labelledby="project-approach-title">
        <span className="project-approach-label">Votre besoin, votre outil</span>
        <div>
            <h3 id="project-approach-title">Vous avez une autre idée de projet&nbsp;?</h3>
            <p>
                Chaque entreprise travaille différemment. Présentez-nous votre besoin, même s’il ne ressemble
                pas aux exemples ci-dessous&nbsp;: nous prenons le temps d’étudier avec vous ce qui est utile et
                réalisable, puis nous concevons une solution adaptée à votre organisation et à votre budget.
            </p>
            <button type="button" className="project-approach-button" onClick={onContact}>
                Parler de mon projet
            </button>
        </div>
    </aside>
)

export default ProjectApproach
